import {FacebookLoginWrapper} from './components/wrapper'

export const PageFacebookLogin = ({...props}) => {
  return <FacebookLoginWrapper {...props} />
}
